import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

const footerColumns = [
  {
    title: "Categories",
    links: [
      { label: "Sets", url: categories[6].url },
      { label: "Underwear/Underpants", url: categories[7].url },
      { label: "Jersey", url: categories[8].url },
    ],
  },
  {
    title: "More",
    links: [
      { label: "Accessories", url: categories[9].url },
      { label: "Bags", url: categories[10].url },
      { label: "Belts", url: categories[11].url },
    ],
  },
  {
    title: "Others",
    links: [
      { label: "Perfumes", url: categories[12].url },
      { label: "OtherStuff", url: categories[13].url },
      { label: "Shoes", url: categories[0].url },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Mulebuy Spreadsheet", url: mainSiteUrl },
      { label: "Buy It Now", url: mainSiteUrl },
      { label: "Home", url: "/", isInternal: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-white">
      {/* Top Section */}
      <div className="w-full px-6 md:px-10 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left: Brand + Newsletter */}
          <div className="lg:w-2/5">
            <div className="flex items-center gap-2 mb-6">
              <span className="text-xl md:text-2xl font-heading font-semibold text-white">
                mulebuyspreadsheet<span className="text-accent-500">.</span>today
              </span>
            </div>

            {/* Newsletter */}
            <form
              data-readdy-form="true"
              id="newsletter-footer"
              action="https://readdy.ai/api/form/d8sn3rde8ise6dlc8udg"
              method="POST"
              className="flex items-center gap-2 mb-6 max-w-sm"
            >
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                className="flex-1 px-4 py-3 rounded-full bg-white/10 border border-white/20 text-white text-sm placeholder:text-white/40 focus:outline-none focus:border-accent-400/60 transition-colors"
              />
              <button
                type="submit"
                className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-white hover:bg-accent-600 transition-all cursor-pointer flex-shrink-0"
              >
                <i className="ri-notification-3-line text-lg"></i>
              </button>
            </form>

            <p className="text-2xl md:text-3xl font-heading font-light text-white/90 leading-tight">
              Smart Shopping
              <br />
              Starts Here
            </p>
          </div>

          {/* Right: Navigation Grid */}
          <div className="lg:w-3/5 grid grid-cols-2 md:grid-cols-4 gap-8">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-medium text-white/60 uppercase tracking-wider mb-4">
                  {col.title}
                </h4>
                <ul className="space-y-3">
                  {col.links.map((link) =>
                    link.isInternal ? (
                      <li key={link.label}>
                        <Link
                          to={link.url}
                          className="text-sm text-white/80 hover:text-accent-400 transition-colors whitespace-nowrap"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ) : (
                      <li key={link.label}>
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-white/80 hover:text-accent-400 transition-colors whitespace-nowrap"
                        >
                          {link.label}
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="w-full px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            &copy; {new Date().getFullYear()} mulebuyspreadsheet.today — All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/20 text-white/70 hover:text-white hover:border-white/40 transition-all cursor-pointer"
              aria-label="Main site"
            >
              <i className="ri-external-link-line text-sm"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/20 text-white/70 hover:text-white hover:border-white/40 transition-all cursor-pointer"
              aria-label="Share"
            >
              <i className="ri-share-forward-line text-sm"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/20 text-white/70 hover:text-white hover:border-white/40 transition-all cursor-pointer"
              aria-label="Bookmark"
            >
              <i className="ri-bookmark-line text-sm"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/20 text-white/70 hover:text-white hover:border-white/40 transition-all cursor-pointer"
              aria-label="More"
            >
              <i className="ri-more-line text-sm"></i>
            </a>
          </div>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-white/50 hover:text-white/80 transition-colors whitespace-nowrap"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}